export default "__VITE_ASSET__xxIukG2C__"